import Greek from './entries/el-GR';
import Enlang from './entries/en-US';
import { addLocaleData } from 'react-intl';

const AppLocale = {
  el: Greek,
  en: Enlang,
};
addLocaleData(AppLocale.el.data);
addLocaleData(AppLocale.en.data);

export default AppLocale;
